export default __webpack_public_path__ + "assets/date.793a7217.svg";